import type { ReactNode } from 'react';
import { Icon } from './Icon';

// A secret shown once (a source's token, a new password): big enough to read, a button to copy, what to do with it.
export function Secret(props: {
    title: string;
    value: string;
    note: ReactNode;
    extra?: string;
    onCopy: (what: string) => void;
    onClose: () => void;
}): ReactNode {
    return (
        <div className="panel secret">
            <div className="sheet-head">
                <div>
                    <h2>{props.title}</h2>
                    <p>Shown once: keep it now.</p>
                </div>
                <button className="closebtn" onClick={props.onClose} title="I have kept it">
                    <Icon name="x" size={17} />
                </button>
            </div>
            <div className="secret-body">
                <div className="secret-value">
                    <code>{props.value}</code>
                    <button
                        className="act primary"
                        onClick={() => {
                            void navigator.clipboard.writeText(props.value);
                            props.onCopy('Copied');
                        }}
                    >
                        <Icon name="copy" size={15} /> Copy
                    </button>
                </div>
                {props.extra && (
                    <div className="secret-value">
                        <pre>{props.extra}</pre>
                        <button
                            className="act"
                            onClick={() => {
                                void navigator.clipboard.writeText(props.extra as string);
                                props.onCopy('Snippet copied');
                            }}
                        >
                            <Icon name="copy" size={15} /> Copy
                        </button>
                    </div>
                )}
                <div className="secret-note">{props.note}</div>
            </div>
        </div>
    );
}
